<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import { GetLogoutUrl } from '../stores/SettingsStore.ts'
import { Button as KButton } from '@progress/kendo-vue-buttons'
import { useLogger } from 'vue-logger-plugin'
import { useCookies } from 'vue3-cookies'

const logger = useLogger()
const { cookies } = useCookies()

async function logoutClickedHandler() {
  logger.debug('logoutClickedHandler')

  // Only remove the cookie, not the localStorage data
  // This allows the cart to persist for this user when they log back in
  cookies.remove('AoeCartIdToken')

  window.location.href = await GetLogoutUrl()
}
</script>
<template>
  <div class="aoe-logout-button">
    <KButton :fill-mode="'clear'" @click="logoutClickedHandler">{{ t('labels.Logout') }}</KButton>
  </div>
</template>
